'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$20() {
  this.aL5 = null;
  this.aL6 = false;
}
export { $c_Lpresto_DashboardView$$anon$20 as $c_Lpresto_DashboardView$$anon$20 };
$p = $c_Lpresto_DashboardView$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$20;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$20() {
}
export { $h_Lpresto_DashboardView$$anon$20 as $h_Lpresto_DashboardView$$anon$20 };
$h_Lpresto_DashboardView$$anon$20.prototype = $p;
$p.P = (function() {
  if ((!this.aL6)) {
    this.aL5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aL6 = true;
  }
  return this.aL5;
});
var $d_Lpresto_DashboardView$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$20, "presto.DashboardView$$anon$20", ({
  GU: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_DashboardView$$anon$20 as $d_Lpresto_DashboardView$$anon$20 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$20.js.map
